import styles from './DetailRow.module.scss';

interface IProps {
    label: React.ReactNode;
    value: React.ReactNode;
}

const DetailRow = ({label, value}: IProps) => {
    if (!value) {
        return null;
    }

    return (
        <div className={styles.detailRow}>
            <div className={styles.detailRowLabel}>{label}</div>
            <div className={styles.detailRowValue} data-notranslate>
                {value}
            </div>
        </div>
    );
};

export default DetailRow;
